export const alertText="Selected Language is not available.";
export const singUpAct="Signed up activities"
export const wouldYouJoin="Would you care to join us?"
export const wantToJoin="WANT TO JOIN OTHER ACTIVITES"
export const viewAll="VIEW ALL"
export const iWould="I would like to..."
export const RoomTemp="Room Temp."
export const tempCont="Temp. Control"
export const experiences="Experiences"
export const noThanks="No thanks"
export const signMeUp="Sign me up"
export const movieList="Videos" 
export const youPick="Your Picks"
export const hotelReao="Hotel Recommendations" 
export const yes="YES"
export const no="NO"
export const roomAssis="Do you wish to call for room assistance?"
export const roomAssisRes="Thank you! Your request has been processed.Kindly wait for your Butler to arrive shortly."
export const roomCont="Room Control"
export const selectCont="Please select a controls"
export const setAndCon="Settings and configs"
export const tvChan="TV Channels"
export const brodToTv="Broadcasting to TV..."
export const vodTitle="VOD Movie Lists: Recommended for you "
//this will response with day title for each number
export const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
]

//this is to get months title from there number
export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
]

export const allGreeting = [
  "Good Morning",
  "Good Afternoon",
  "Good Evening"
]
